import { alpha, useTheme } from '@mui/material';
const useIncidentTileStyles = () => {
    const theme = useTheme();
    return {
        tileStyles: {
            display: 'flex',
            flexDirection: 'row',
            gap: '12px',
            py: 1.5,
            px: 2,
            width: '100%',
            cursor: 'pointer',
            alignItems: 'center',
        },
        imageContainerStyles: {
            width: 46,
            height: 46,
            borderRadius: '8px',
            position: 'relative',
            overflow: 'hidden'
        },
        imageStyles: {
            width: '100%',
            height: '100%',
            objectFit: 'cover'
        },
        eyeStyles: {
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)'
        },
        tileContentContainerStyles: {
            display: 'flex',
            flex: 1,
            flexDirection: 'column',
            gap: 0.5,
            justifyContent: 'center'
        },
        incidentCountChipStyles: {
            fontSize: 13,
            fontWeight: 500,
            lineHeight: '18px',
            textAlign: 'center',
            height: 28,
            color: theme.palette.error.dark,
            background: alpha(theme.palette.error.main, 0.16),
        },
        alertIconStyles: {
            width: 65,
            height: 30,
            borderRadius: '100px',
            display: 'flex',
            gap: 0.5,
            alignItems: 'center',
            justifyContent: 'center',
            color: theme.palette.common.white,
        }
    };
};
export default useIncidentTileStyles;
